import { clone } from '@edicom/common/object/clone';
import { compare } from '@edicom/common/object/compare';
import { match } from '@edicom/common/object/match';

export default {
  clone, // copia un objeto recursivamente
  compare, // compara recursivamente dos objetos por valores (no por referencia)
  match, // sobreescribe las propiedadas (recursivamente) de un objeto con las de otro (uso por ejemplo en IECES)
};
